import React from 'react';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { AuthenticatedApp } from './components/AuthenticatedApp';
import Activate from './components/Activate';
import { WebSocketProvider } from './contexts/WebSocketContext';

function VerifyUserOverride() {
  const { skipVerification } = useAuthenticator();

  // Automatically skip verification when this component renders
  React.useEffect(() => {
    if (skipVerification) {
      console.log('Auto-skipping verification');
      skipVerification();
    }
  }, [skipVerification]);

  // Return null to hide the UI while skipVerification is being called
  return null;
}

// Self-service escape hatch on the login screen: partners who are locked out
// (expired temp password, forgotten password) can email themselves a secure
// magic link instead of contacting support.
function SignInFooter() {
  return (
    <div style={{ textAlign: 'center', padding: '0 1rem 1.5rem' }}>
      <a
        href="/activate"
        data-testid="get-help-logging-in"
        style={{ color: '#1aafff', fontWeight: 600, fontSize: '0.9rem', textDecoration: 'none' }}
      >
        Get help logging in
      </a>
    </div>
  );
}

export default function AppWithAuth() {
  // No router in this app — the magic-link activation page is a standalone
  // screen rendered outside the Authenticator so it can drive its own sign-in.
  if (window.location.pathname === '/activate') {
    return <Activate />;
  }

  return (
    <Authenticator
      hideSignUp={true}
      loginMechanisms={['email']}
      components={{
        VerifyUser: VerifyUserOverride,
        SignIn: {
          Footer: SignInFooter,
        },
      }}
    >
      <WebSocketProvider>
        <AuthenticatedApp />
      </WebSocketProvider>
    </Authenticator>
  );
}